import * as Yup from "yup";

const RedeemPromoSchema = Yup.object().shape({
  promoCode: Yup.string().required("Promo Code field should not be empty"),
});

export { RedeemPromoSchema };
export default RedeemPromoSchema;
